import { Component, EventEmitter, Input, Output } from '@angular/core';
import { articleDetail } from 'src/interface/article';

@Component({
  selector: 'app-toaster-downloading',
  templateUrl: './toaster-downloading.component.html',
  styleUrls: ['./toaster-downloading.component.scss']
})

export class ToasterDownloadingComponent  {

  @Input() downloading: boolean;
  @Input() downloadingData: { filename: string, download: boolean }[] = [];
  @Input() disableBtnPdf = true;
  @Input() filename: string;
  @Input() downloadCount: number;
  @Output() downloadcount = new EventEmitter<number>();
  @Input() pdfnotexist:boolean;


  @Input() articlelist: articleDetail;
  disableBtnXml = true;
 

  resetDownloadData() {
    this.downloadingData = [];
    this.disableBtnPdf = false;
    this.downloading = false;
    this.disableBtnXml = false;
    this.downloadCount = -1
    this.downloadcount.emit(this.downloadCount)

  }

  

}
